import { SVG, SVGProps } from './svg'

export function IconMore(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M6 10a2 2 0 110 4 2 2 0 010-4zm8 2a2 2 0 10-4 0 2 2 0 004 0zm4-2a2 2 0 110 4 2 2 0 010-4z" />
    </SVG>
  )
}
